<!--站点运营-->
<template>
    <div>
        <top-bar
            title="运营"
            :height="'48vh'"
            :isShowRefresh="false"
            icon="iconfont icon-yunying"
        />
        <v-container fluid class="mt-n6">
            <!-- <v-row>
                <v-col cols="3" md="3" v-for="(item, index) in label" :key="index">
                    <el-card
                        shadow="hover"
                        style="height:100%"
                        :style="{ backgroundColor: theme.elementBgColor, border: 'none' }"
                    >
                        <v-row>
                            <v-col
                                cols="12"
                                md="4"
                                align="center"
                                justify="center"
                                style="background-color:#e9ecef"
                            >
                                <v-img
                                    v-if="index === 0"
                                    width="3em"
                                    contain
                                    height="3em"
                                    src="@/assets/Station/site.png"
                                ></v-img>
                                <i
                                    v-else
                                    :class="item.icon"
                                    :style="{ color: item.iconColor, fontSize: '2.2em' }"
                                ></i>
                            </v-col>
                            <v-col cols="12" md="8" align="center" justify="center">
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        :style="{
                                            fontSize: '1.5vw',
                                            color: theme.pageFontColor,
                                        }"
                                    >
                                        {{ item.nums }}
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="mt-n6"
                                        :style="{
                                            fontSize: '1vw',
                                            color: theme.pageFontColor,
                                        }"
                                    >
                                        {{ item.title }}
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </el-card>
                </v-col>
                <v-col cols="12" md="8">
                    <el-card
                        shadow="hover"
                        :style="{ backgroundColor: theme.elementBgColor, border: 'none' }"
                    >
                        <v-row>
                            <v-col cols="12" md="12">
                                <el-tag type="danger">
                                    <v-btn
                                        text
                                        icon
                                        color="red"
                                        :loading="loading"
                                        @click="refresh()"
                                    >
                                        <v-icon>mdi-cached</v-icon>
                                    </v-btn>
                                    故障设备信息
                                </el-tag>
                            </v-col>
                            <v-col cols="12" md="12">
                                <fault-equipment :faultData="faultData" />
                            </v-col>
                        </v-row>
                    </el-card>
                </v-col>
            </v-row> -->
            <div class="site-echarts center" :style="{ backgroundColor: theme.elementBgColor }">
                <div class="search-date">
                    <div class="refresh">
                        <v-btn text icon :loading="loading" @click="refresh()">
                            <v-icon>mdi-cached</v-icon>
                        </v-btn>
                    </div>
                    <div class="selectTime center">
                        <el-date-picker
                            v-model="time"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp"
                            style="width:100%"
                            :picker-options="pickerOptions"
                            @change="timeChange"
                        ></el-date-picker>
                    </div>
                </div>
                <div class="echarts center ">
                    <site-money-echarts />
                </div>
            </div>
            <div class="site-rank-accounted-echarts">
                <div class="accounted-echarts">
                    <div
                        class="accounted-money-echarts"
                        :style="{ backgroundColor: theme.elementBgColor }"
                    >
                        <accounted-money />
                    </div>
                    <div class="box"></div>
                    <div
                        class="accounted-power-echarts"
                        :style="{ backgroundColor: theme.elementBgColor }"
                    >
                        <accounted-power />
                    </div>
                </div>
                <div class="box2"></div>
                <div class="rank-echarts center" :style="{ backgroundColor: theme.elementBgColor }">
                    <site-rank-echarts />
                </div>
            </div>
        </v-container>
    </div>
</template>
<script>
import FaultEquipment from "@/components/Table/FaultEquipment";
import SiteMoneyEcharts from "@/components/Echarts/SiteMoneyEcharts";
import SiteRankEcharts from "@/components/Echarts/SiteRankEcharts";
import AccountedPower from "@/components/Echarts/AccountedPower";
import AccountedMoney from "@/components/Echarts/AccountedMoney";
import TopBar from "@/components/TopBar";
import { mapState } from "vuex";
import store from "@/store";
import Public from "@/public";
export default {
    name: "StationOperating",
    data() {
        let that = this;
        return {
            loading: false,
            faultData: [],
            label: [
                {
                    icon: "",
                    iconColor: "",
                    title: "站点总计",
                    nums: 100,
                },
                {
                    icon: "iconfont icon-chongdianzhuang2",
                    iconColor: "#FFAE4D",
                    title: "设备总计",
                    nums: 10,
                },
                {
                    icon: "iconfont icon-chongdianzhuang2",
                    iconColor: "#D81E06",
                    title: "故障设备",
                    nums: 10,
                },
                {
                    icon: "iconfont icon-chongdianzhuang2",
                    iconColor: "#CDCDCD",
                    title: "空闲设备",
                    nums: 10,
                },
            ],
            time: null,
            pickerOptions: {
                shortcuts: [
                    {
                        text: "昨天",
                        onClick(picker) {
                            const now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            let start = new Date(lastData).getTime() - 8 * 60 * 60 * 1000;
                            let end = start + 23 * 3600 * 1000 + 59 * 60000 + 59 * 1000;
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 7);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 30);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 90);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        ...mapState(["theme", "siteOrderSummary"]),
    },
    components: {
        FaultEquipment,
        TopBar,
        SiteMoneyEcharts,
        AccountedPower,
        AccountedMoney,
        SiteRankEcharts,
    },
    methods: {
        timeChange(event) {
            if (!event) {
                return;
            }
            this.search();
        },
        refresh() {
            this.search();
            // this.loading = true;
            // this.faultData = [
            //     {
            //         time: "2020/12/10",
            //         id: "2",
            //         site: "站点1",
            //         address: "江西省南昌市西湖区",
            //         people: "小明",
            //         phone: "123456778",
            //     },
            //     {
            //         time: "2020/12/10",
            //         id: "3",
            //         site: "站点1",
            //         address: "江西省南昌市西湖区",
            //         people: "小明",
            //         phone: "123456778",
            //     },
            //     {
            //         time: "2020/12/10",
            //         id: "4",
            //         site: "站点1",
            //         address: "江西省南昌市西湖区",
            //         people: "小明",
            //         phone: "123456778",
            //     },
            // ];
        },
        firstTimeData() {
            let dayTime = new Date();
            // let Y = dayTime.getFullYear();
            // let M = dayTime.getMonth() + 1;
            // let D = dayTime.getDate();
            let end_time = Math.floor(dayTime.getTime());
            // var datetime = Y + "-" + (M < 10 ? "0" + M : M) + "-" + (D < 10 ? "0" + D : D);
            // let lw = new Date(dayTime - 1000 * 3600 * 24 * 60);
            // let lastY = lw.getFullYear();
            // let lastM = lw.getMonth() + 1;
            // let lastD = lw.getDate();
            // let startThirtydate =
            //     lastY +
            //     "-" +
            //     (lastM < 10 ? "0" + lastM : lastM) +
            //     "-" +
            //     (lastD < 10 ? "0" + lastD : lastD);
            // let beforeDate = new Date(startThirtydate + " 00:00:01");
            // let start_time = Math.floor(beforeDate.getTime());
            // this.getSiteOrderSummary(start_time, end_time);
            let start_time = new Date(this.getDate("month", -2)).getTime() + 24 * 3600000;
            this.time = [start_time, end_time];
            this.search();
        },
        /*搜索*/
        search() {
            if (this.time == null) {
                this.firstTimeData();
                return;
            }
            // let start_time = new Date(Public.longDataToStr(this.time[0]).split(" ")[0]).getTime();
            let start_time = new Date(this.time[0]).getTime();
            let end_time =
                new Date(Public.longDataToStr(this.time[1]).split(" ")[0]).getTime() -
                8 * 1000 * 3600 +
                24 * 3600 * 1000;
            // console.log(start_time);
            // console.log(end_time);
            console.log(Public.longDataToStr(start_time));
            console.log(Public.longDataToStr(end_time));
            this.getSiteOrderSummary(start_time, end_time);
        },
        async getSiteOrderSummary(start_time, end_time) {
            this.loading = true;
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 2,
                },
                callback: () => {
                    this.loading = false;
                },
            };
            await store.dispatch("getOrderSummary", params);
        },
        getDays(date) {
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var d = new Date(year, month, 0);
            return d.getDate();
        },
        getDate(type = null, number = 0) {
            var nowdate = new Date();
            let retrundate;
            switch (type) {
                case "day": //取number天前、后的时间
                    nowdate.setTime(nowdate.getTime() + 24 * 3600 * 1000 * number);
                    var y = nowdate.getFullYear();
                    var m = nowdate.getMonth() + 1;
                    var d = nowdate.getDate();
                    retrundate = y + "-" + m + "-" + d;
                    break;
                case "week": //取number周前、后的时间
                    var weekdate = new Date(nowdate + 7 * 24 * 3600 * 1000 * number);
                    var y = weekdate.getFullYear();
                    var m = weekdate.getMonth() + 1;
                    var d = weekdate.getDate();
                    retrundate = y + "-" + m + "-" + d;
                    break;
                case "month": //取number月前、后的时间
                    nowdate.setMonth(nowdate.getMonth() + number);
                    var y = nowdate.getFullYear();
                    var m = nowdate.getMonth() + 1;
                    var d = nowdate.getDate();
                    retrundate = y + "-" + m + "-" + d;
                    break;
                case "year": //取number年前、后的时间
                    nowdate.setFullYear(nowdate.getFullYear() + number);
                    var y = nowdate.getFullYear();
                    var m = nowdate.getMonth() + 1;
                    var d = nowdate.getDate();
                    retrundate = y + "-" + m + "-" + d;
                    break;
                default:
                    //取当前时间
                    var y = nowdate.getFullYear();
                    var m = nowdate.getMonth() + 1;
                    var d = nowdate.getDate();
                    retrundate = y + "-" + m + "-" + d;
            }
            return retrundate;
        },
    },
};
</script>
<style scoped>
@import "../../assets/css/stationOperating.css";
.site-echarts {
    width: 100%;
    height: 40rem;
    border-radius: 2rem;
}
/* .site-rank-accounted-echarts {
    margin-top: 2rem;
    width: 100%;
    height: 45rem;
    display: flex;
    flex-direction: row;
}
.accounted-echarts {
    width: 49%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.accounted-money-echarts {
    width: 100%;
    height: 49%;
    border-radius: 2rem;
}
.box {
    width: 100%;
    height: 2%;
}
.box2 {
    width: 2%;
    height: 100%;
}
.accounted-power-echarts {
    width: 100%;
    height: 49%;
    border-radius: 2rem;
}
.rank-echarts {
    width: 49%;
    height: 100%;
    border-radius: 2rem;
}
.search-date {
    width: 100%;
    height: 15%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
}
.refresh {
    position: absolute;
    left: 2rem;
}
.echarts {
    width: 100%;
    height: 85%;
}
.selectTime {
    width: 40%;
    height: 100%;
}
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
} */
</style>
